import { BrowserRouter } from "react-router-dom"
import { Suspense } from "react"
import { PageLoader } from "src/shared/components"
import Routes from "src/routes"

import AuthProvider from "./shared/store/slices/auth/auth-provider"

function App() {
  return (
    <>
      {/* React 19: Native document metadata support */}
      <title>Harbor - Your Application</title>
      <meta name="description" content="Harbor application - Modern React 19 powered dashboard" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />

      {/* React 19: Enhanced Suspense with better error boundaries */}
      <Suspense fallback={<PageLoader isLoading={true} />}>
        <AuthProvider>
          <BrowserRouter>
            <Routes />
          </BrowserRouter>
        </AuthProvider>
      </Suspense>
    </>
  )
}

export default App
